// src/httpClient.ts
import { fetchUtils } from "react-admin";
import keycloak from "./keycloak";

/**
 * ZENTRALER httpClient für react-admin
 * - refresht Token vor JEDEM Request
 * - setzt IMMER das aktuelle Access Token
 * - verhindert 401-Logout-Kaskaden
 * - WICHTIG: setzt KEIN Content-Type bei FormData (multipart boundary!)
 */
export const httpClient = async (
  url: string,
  options: fetchUtils.Options = {}
) => {
  const opts = { ...options };

  // Headers sicher initialisieren
  opts.headers =
    opts.headers instanceof Headers
      ? opts.headers
      : new Headers(opts.headers || {});

  // Optional, aber praktisch
  if (!opts.headers.has("Accept")) {
    opts.headers.set("Accept", "application/json");
  }

  // 🔑 WICHTIGSTER TEIL: vor jedem Request Token aktualisieren
  if (keycloak.authenticated) {
    try {
      await keycloak.updateToken(60); // refresht wenn <60s gültig
      opts.headers.set("Authorization", `Bearer ${keycloak.token}`);
    } catch (err) {
      console.error("[httpClient] token refresh failed", err);
      throw err; // react-admin handled authProvider.checkError
    }
  }

  // ---- FormData Fix (entscheidend für UploadFile/File(...)) ----
  const body: any = (opts as any).body;
  const isFormData =
    typeof FormData !== "undefined" && body instanceof FormData;

  if (isFormData) {
    // Browser setzt multipart/form-data inkl. boundary selbst
    opts.headers.delete("Content-Type");
  } else {
    // JSON default (wie vorher), aber nur wenn wir wirklich JSON senden wollen
    if (!opts.headers.has("Content-Type")) {
      opts.headers.set("Content-Type", "application/json");
    }
  }
  // -------------------------------------------------------------

  return fetchUtils.fetchJson(url, opts);
};
